// Inbound tracking (N7) and order updates (migration 055): the carriers people pick from and each one's tracking page.
// No zod here, so the vendor portal's page can use them (shared/po.ts re-exports them).
/** Carriers people pick from (any other name can be typed). */
export const CARRIERS = ["DHL", "FedEx", "UPS", "USPS", "SF Express", "Sea freight", "Air freight"] as const;

/** The carrier's tracking page for a number, for the carriers it's known for; null otherwise. */
export function trackingUrl(carrier: string, number: string): string | null {
  const n = encodeURIComponent(number.trim());
  if (!n) return null;
  const c = carrier.trim().toLowerCase();
  if (c.startsWith("dhl")) return `https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id=${n}`;
  if (c.startsWith("fedex")) return `https://www.fedex.com/fedextrack/?trknbr=${n}`;
  if (c.startsWith("ups")) return `https://www.ups.com/track?tracknum=${n}`;
  if (c.startsWith("usps")) return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${n}`;
  if (c.startsWith("sf")) return `https://www.sf-international.com/us/en/dynamic_function/waybill/#search/bill-number/${n}`;
  return null;
}
